import { LoginForm } from '@/features/identity/components/LoginForm';

export function LoginPage() {
  return <LoginForm />;
}
